"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require("lru-memoize");

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require("../../utils/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loginValidator = (0, _validation.createValidator)({
  email: [_validation.required, _validation.email],
  password: [_validation.required]
});
exports.default = (0, _lruMemoize2.default)(10)(loginValidator);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Login/loginValidator.js
 ** module id = 491
 ** module chunks = 0
 **/